// This file was generated by https://github.com/redbubble/design/blob/master/scripts/generateIcons.js
import React from 'react';
import Icon from '../Icon';

const SocialXIcon = (props?: any) => <Icon {...props} dangerouslySetIcon={'<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" viewBox="0 0 24 24" fill="currentColor" xml:space="preserve"><path transform=" translate(1.5, 1.5)" d="M 17.325 0.222229 L 20.6989 0.222229 L 13.3289 8.66709 L 22 20.1605 L 15.2114 20.1605 L 9.89057 13.1912 L 3.80914 20.1605 L 0.432143 20.1605 L 8.31443 11.1248 L 0 0.2238 L 6.96143 0.2238 L 11.7637 6.5928 L 17.325 0.222229 Z M 16.1386 18.1365 L 18.0086 18.1365 L 5.94 2.14094 L 3.93486 2.14094 L 16.1386 18.1365 Z" stroke-linecap="round" /></svg>'} />;

(SocialXIcon as any).displayName = 'SocialXIcon';

export default SocialXIcon;
